import React, { useMemo } from "react";
import FormGeneric from "../../../../shared/components/generic/form/form-generic";
import TableGeneric from "../../../../shared/components/generic/table/table-generic";
import Pagination from "../../../../shared/components/generic/pagination/pagination";
import { getClientSearchFormConfig } from "../../config/client-search-form-config";
import { getDashboardParticipantClientsColumns } from "../../config/participant-clients-columns-config";
import "./dashboard-client-search.css";

const DashboardClientSearch = ({
	clientSearchDocument = "",
	clientSearchFormResetKey = 0,
	selectedClient = null,
	isExpanded = true,
	participantClients = [],
	participantClientsPagination = {},
	participantClientsLoading = false,
	onClientSearchDocumentChange,
	onSearch,
	onPageChange,
	onSelectClient,
	onToggleExpanded
}) => {
	const columns = useMemo(() => {
		return getDashboardParticipantClientsColumns({
			onSelectClient,
			actionTitle: "Exibir resultados",
			actionVariant: "view"
		});
	}, [onSelectClient]);

	const selectedClientColumns = useMemo(() => {
		return getDashboardParticipantClientsColumns({
			onSelectClient: onToggleExpanded,
			actionTitle: "Ocultar resultados",
			actionVariant: "viewOff"
		});
	}, [onToggleExpanded]);

	const tableClients = useMemo(() => {
		if (!selectedClient?.document) {
			return participantClients;
		}

		return participantClients.filter(client => {
			return client.document !== selectedClient.document;
		});
	}, [participantClients, selectedClient]);

	const shouldShowSelectedClient = Boolean(selectedClient);
	const shouldShowSearchArea = isExpanded || !selectedClient;
	const shouldShowTable = shouldShowSearchArea && tableClients.length > 0;

	const isSearchButtonDisabled =
		participantClientsLoading || !clientSearchDocument?.trim();

	return (
		<div className="dashboard-client-search">
			{shouldShowSelectedClient && (
				<div className="dashboard-client-search__selected">
					<TableGeneric
						columns={selectedClientColumns}
						data={[selectedClient]}
						rowKey="document"
					/>
				</div>
			)}

			{shouldShowSearchArea && (
				<>
					<FormGeneric
						key={`dashboard-client-search-form-${clientSearchFormResetKey}`}
						formId="dashboard-client-search-form"
						formFields={getClientSearchFormConfig(clientSearchDocument)}
						message="Buscar"
						isSubmitDisabled={isSearchButtonDisabled}
						buttonStartIcon="search"
						buttonWidth="160px"
						onFieldChange={({ name, value }) => {
							if (name === "clientSearchDocument") {
								onClientSearchDocumentChange(value);
							}
						}}
						onSubmit={onSearch}
					/>

					{shouldShowTable && (
						<div className="dashboard-client-search__results">
							<TableGeneric
								columns={columns}
								data={tableClients}
								rowKey="document"
							/>

							{participantClientsPagination.totalPages > 1 && (
								<Pagination
									pageCount={participantClientsPagination.totalPages}
									currentPage={participantClientsPagination.page}
									onPageChange={onPageChange}
								/>
							)}
						</div>
					)}
				</>
			)}
		</div>
	);
};

export default DashboardClientSearch;